export default __webpack_public_path__ + "static/media/mytime.7ada545e.svg";